import { ServerConnection } from "src/server/serverConnection";
import { IFileDownloader } from "src/uicomponents/components/fileSelector/fileSelector-viewModel";

export class ImportBillFileDownloader implements IFileDownloader{
    public purchaseBillId:string;    
    async download(fileId: string, filename: string): Promise<{ name: string; content: string; }> {
        let result = await ServerConnection.callServer('/Complex/ImportProductServices/GetPurchaseBillFile',{
            BillId : this.purchaseBillId,
            FileId : fileId
        });
        return {
            name : filename,
            content : result.Content
        };
    }
}